import { TForgotPasswordInput } from "@/types/api/Auth/ForgotPassword";
import { TResponse } from "@/types/api/api";
import { API_URL } from "@/utils/const/api";
import { usePost } from "@/utils/query";

export const useForgotPassword = () => usePost<TForgotPasswordInput, TResponse>(API_URL.FORGOT_PASSWORD);
export const useVerifyResetPassword = () => usePost<{ code: string | number }, TResponse>(`${API_URL.VERIFY_RESET_PASSWORD}`);
export const useResetPassword = () => usePost<{ password: string, code: string | number }, TResponse>(`${API_URL.RESET_PASSWORD}`);
